import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { AutomationService } from 'src/app/services/automation.service';
import { ControlService } from 'src/app/services/control.service';
import { DeviceColumnService } from 'src/app/services/device-column.service';
import { DeviceService } from 'src/app/services/device.service';
import { EncryptionDecryptionService } from 'src/app/services/encryption-decryption.service';
import { GroupService } from 'src/app/services/group.service';
import { InstallService } from 'src/app/services/install.service';
import { LogcatService } from 'src/app/services/logcat.service';
import { LoginService } from 'src/app/services/login.service';
import { ScalingService } from 'src/app/services/scaling.service';
import { SettingsService } from 'src/app/services/settings.service';
import { StackService } from 'src/app/services/stack-service.service';
import { StandaloneService } from 'src/app/services/standalone.service';
import { StorageService } from 'src/app/services/storage.service';
import { VendorUtilService } from 'src/app/services/vendor-util.service';
import { ImagePool } from '../device-control/device-screen/image-pool';
import * as pako from 'pako';
import { TrackerService } from 'src/app/services/tracker.service';
import { CommonService } from 'src/app/services/common.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-slave-selection',
    templateUrl: './slave-selection.component.html',
    styleUrls: ['./slave-selection.component.css'],
    standalone: true,
    imports: [TranslateModule, CommonModule, FormsModule]
})
export class SlaveSelectionComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('alertMod') alertTemplate: TemplateRef<any>;
  device: any;
  control: any;
  subscription: any;
  tracker: TrackerService;
  private listeners: { [key: string]: EventListener } = {};
  modalRef!: MatDialogRef<any>;
  aboutDevice: boolean = false;
  wsAppium: any;
  ws: WebSocket; // Added declaration for ws
  element: HTMLElement;
  screen: any;
  cssTransform: any;
  canvasAspect: number;
  isScreenRotated: boolean = false;
  loader: boolean = true;
  cursor: string = 'wait';
  displayError: any;
  BLANK_IMG: any;
  URL: any;
  scaler: any;
  prevCoords: { x?: number; y?: number } = {};
  input: HTMLInputElement;
  value: any;
  currentUser: any;
  email: any;
  msg: string;
  appInstalling: boolean = false;
  progress: number = 0;
  screenRecord: boolean = false;
  bridgeHost: any;
  list: any;
  items: any;
  activeColumns = [];
  activeFilters = [];
  activeSorting = [];
  columnDefinitions: any;
  unsubscribe: any;
  mapping = {
    0: {
      0: 0
      , 90: -90
      , 180: -180
      , 270: 90
    }
    , 90: {
      0: 90
      , 90: 0
      , 180: -90
      , 270: 180
    }
    , 180: {
      0: 180
      , 90: 90
      , 180: 0
      , 270: -90
    }
    , 270: {
      0: -90
      , 90: -180
      , 180: 90
      , 270: 0
    }
  }
  prefix = 'd' + Math.floor(Math.random() * 1000000) + '-';
  priorityOrder = {
    'Stop Using': 0,
    'Use': 1,
    'Preparing': 2,
    'Ready': 3,
    'Busy': 4,
    'Connected': 5,
    'Unauthorized': 6,
    'Stop Automation': 7,
    'Offline': 8,
    'Disconnected': 9,
    'Unknown': 10
  };
  selectedDevices: string[] = []; // Array to store selected device serials
  maxSelections = 4;
  minSelections = 1;
  packageName: string;

  constructor(
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private router: Router,
    private vendorUtilService: VendorUtilService,
    private storageService: StorageService,
    private scalingService: ScalingService,
    private renderer: Renderer2,
    private controlService: ControlService,
    private loginService: LoginService,
    private dialog: MatDialog,
    private standaloneService: StandaloneService,
    private stackService: StackService,
    private logcatService: LogcatService,
    private installService: InstallService,
    private groupService: GroupService,
    private settingsService: SettingsService,
    private deviceColumnService: DeviceColumnService,
    private deviceService: DeviceService,
    private automationService: AutomationService,
    private encryptionDecryptionService: EncryptionDecryptionService,
    private commonService: CommonService
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }
  ngOnDestroy(): void {
    this.unsubscribe?.();
  }
  ngAfterViewInit(): void {
    this.subscription = this.tracker.trackerEventEmitter.subscribe((data: any) => {
      this.list = this.elementRef.nativeElement.querySelector('ul.device-list');
      this.items = Array.from(this.list.children) as Element[];
      
      if (data.type == "add") {
        this.addListener(data.data);
      }
      if (data.type == "change") {
        this.changeListener(data.data);
      }
      if (data.type == "remove") {
        this.removeListener(data.data);
      }
    });
    const element = this.elementRef.nativeElement;
    // Listen for click events on the element
    this.unsubscribe = this.renderer.listen(element, 'click', (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      let id: string;

      if (target.classList.contains('thumbnail')) {
        id = target.id;
      } else if (
        target.classList.contains('device-status') ||
        target.classList.contains('device-photo-small') ||
        target.classList.contains('device-name')
      ) {
        id = ((target.parentNode as HTMLElement).parentNode as HTMLElement).id;
      } else if ((target.parentNode as HTMLElement).classList.contains('device-photo-small')) {
        id = (((target.parentNode as HTMLElement).parentNode as HTMLElement).parentNode as HTMLElement).id;
      }

      if (id) {
        const device = this.mapping[id];
        this.handleDeviceSelection(device, id, target);
      }
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe(async params => {
      try {
        // Get both devices
        this.device = await this.getDevice(params['id']);
        // Check if both devices were loaded successfully
        if (this.device) {
          this.scaler = this.scalingService.coordinator(
            this.device.display.width
            , this.device.display.height
          );
          this.control = this.controlService.create(this.device, this.device.channel);
        } else {
          console.error('Failed to load one or both devices');
        }
      } catch (error) {
        console.error('Error in device loading:', error);
      }
    });
    this.email = this.currentUser.email;
    this.URL = window.URL || window.webkitURL;
    this.BLANK_IMG = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    this.cssTransform = this.vendorUtilService.style(['transform', 'webkitTransform']);
    this.isScreenRotated = false;
    this.element = this.elementRef.nativeElement.firstElementChild.children[0];//mobileScreen div
    console.log(this.currentUser.userObj.groups.subscribed[0], this.device);
    this.tracker = this.deviceService.trackAll();
    this.list = this.elementRef.nativeElement.querySelector('ul');
    this.items = Array.from(this.list.children) as Element[];

    this.displayError = false;
    this.input = this.element.querySelector('input');

    this.screen = {
      rotation: 0
      , bounds: {
        x: 0
        , y: 0
        , w: 0
        , h: 0
      }
    };
  }

  private handleDeviceSelection(device: any, deviceId: string, target: HTMLElement): void {
    const deviceSerial = device.serial;
    const isCurrentlySelected = this.selectedDevices.includes(deviceSerial);
    const thumbnailElement = this.getThumbnailElement(target);
    if (isCurrentlySelected) {
      // Deselect the device
      this.deselectDevice(deviceSerial, thumbnailElement);
    } else {
      // Check if we can select more devices
      if (this.selectedDevices.length >= this.maxSelections) {
        this.msg = `You can select maximum ${this.maxSelections} devices!`;
        this.openAlertMod(this.alertTemplate, this.msg);
        return;
      }

      // Select the device
      this.selectDevice(deviceSerial, thumbnailElement);
    }

    console.log('Selected devices:', this.selectedDevices);
  }

  private selectDevice(deviceSerial: string, thumbnailElement: HTMLElement): void {
    this.selectedDevices.push(deviceSerial);
    this.updateDeviceVisualState(thumbnailElement, true);
  }

  private deselectDevice(deviceSerial: string, thumbnailElement: HTMLElement): void {
    const index = this.selectedDevices.indexOf(deviceSerial);
    if (index > -1) {
      this.selectedDevices.splice(index, 1);
    }
    this.updateDeviceVisualState(thumbnailElement, false);
  }

  private updateDeviceVisualState(thumbnailElement: HTMLElement, isSelected: boolean): void {
    if (isSelected) {
      // Add visual indication for selected device
      thumbnailElement.style.border = '2px solid #007bff';
      thumbnailElement.style.backgroundColor = '#e3f2fd';
      thumbnailElement.classList.add('device-selected');
    } else {
      // Remove visual indication
      thumbnailElement.style.border = '';
      thumbnailElement.style.backgroundColor = 'white';
      thumbnailElement.classList.remove('device-selected');
    }
  }

  private getThumbnailElement(target: HTMLElement): HTMLElement {
    // Navigate up the DOM to find the thumbnail element
    let current = target;
    while (current && !current.classList.contains('thumbnail')) {
      current = current.parentElement as HTMLElement;
    }
    return current;
  }

  // Method to validate selection before proceeding
  public validateSelection(): boolean {
    if (this.selectedDevices.length < this.minSelections) {
      this.msg = `Please select at least ${this.minSelections} device(s)!`;
      this.openAlertMod(this.alertTemplate, this.msg);
      return false;
    }
    return true;
  }

  // Method to get selected devices data
  public getSelectedDevicesData(): any[] {
    return this.selectedDevices.map(serial => {
      // Find device object by serial
      const deviceId = Object.keys(this.mapping).find(key =>
        this.mapping[key].serial === serial
      );
      return deviceId ? this.mapping[deviceId] : null;
    }).filter(device => device !== null);
  }

  // Method to clear all selections
  public clearAllSelections(): void {
    const thumbnailElements = document.querySelectorAll('.device-selected');
    thumbnailElements.forEach(element => {
      this.updateDeviceVisualState(element as HTMLElement, false);
    });
    this.selectedDevices = [];
  }

  // Method to programmatically select devices (if needed)
  public selectDeviceBySerial(serial: string): boolean {
    if (this.selectedDevices.length >= this.maxSelections) {
      return false;
    }

    if (!this.selectedDevices.includes(serial)) {
      const deviceId = Object.keys(this.mapping).find(key =>
        this.mapping[key].serial === serial
      );

      if (deviceId) {
        const thumbnailElement = document.getElementById(deviceId);
        if (thumbnailElement) {
          this.selectDevice(serial, thumbnailElement);
          return true;
        }
      }
    }
    return false;
  }

  public onPackageNameSubmit(): void {
    let slavesSerials: any[] = [];
    this.selectedDevices.forEach((serial: string) => {
      slavesSerials.push(serial);
    });
    console.log('slavesSerials:', slavesSerials,
      '\nAfter encryption:',
       this.encryptionDecryptionService.encryptDeviceSerials(slavesSerials),
       '\nAfter decryption:',
       this.encryptionDecryptionService.decryptDeviceSerials(this.encryptionDecryptionService.encryptDeviceSerials(slavesSerials)));
    
    // Here you would typically call a service to save the configuration
    sessionStorage.setItem('masterDevice', this.device.serial);
    sessionStorage.setItem('slaveDevices', this.encryptionDecryptionService.encryptDeviceSerials(slavesSerials));
    sessionStorage.setItem('packageName', this.packageName);
    let slaveDevices = sessionStorage.getItem('slaveDevices');
    this.commonService.setActiveTab('/control/');
    this.router.navigate(['/control', this.device.serial, 'multi-execution', slaveDevices]);
  }

  public resetPackageName(): void {
    this.packageName = '';
  }

  addListener = (device: any) => {

    let item = this.createItem(device);


    this.filterItem(item, device);
    this.insertItem(item, device);
  };

  // Triggers when the tracker notices that a device changed.
  changeListener(device) {

    let id = this.calculateId(device)
    let item = this.list.children[id]


    if (item) {
      // First, update columns
      this.updateItem(item, device)

      // Maybe the item is not sorted correctly anymore?
      let diff = this.compareItem(item, device)


      if (diff !== 0) {
        // Because the item is no longer sorted correctly, we must
        // remove it so that it doesn't confuse the binary search.
        // Then we will simply add it back.
        this.list.removeChild(item)
        this.insertItem(item, device)
      }
    }
  }

  // Triggers when a device is removed entirely from the tracker.
  removeListener(device) {


    let id = this.calculateId(device)
    let item = this.list.children[id]

    if (item) {
      this.list.removeChild(item)
    }
    delete this.mapping[id]
  }

  calculateId(device) {
    return this.prefix + device.serial
  }

  createItem(device: any) {
    let id = this.calculateId(device)
    let item = this.build();

    item.id = id;


    this.update(item, device)
    this.mapping[id] = device

    return item
  }

  build(): HTMLLIElement {


    const li = document.createElement('li');
    // aliceblue
    this.renderer.setStyle(li, 'background-color', 'white');
    this.renderer.setStyle(li, 'width', '10em');
    this.renderer.setStyle(li, 'margin', '0');
    this.renderer.setStyle(li, 'box-shadow', '2px 2px 4px #88898d');
    this.renderer.setStyle(li, 'border-radius', '8px');
    this.renderer.setStyle(li, 'padding', '5px');
    //for box shadows in device list icons
    this.renderer.listen(li, 'mouseenter', () => {
      this.renderer.setStyle(li, 'box-shadow', '6px 6px 4px rgba(0, 0, 0, 0.2)');
    });
    this.renderer.listen(li, 'mouseleave', () => {
      this.renderer.removeStyle(li, 'transform');
      this.renderer.setStyle(li, 'box-shadow', '2px 2px 4px #88898d');
    });
    this.renderer.listen(li, 'mousedown', () => {
      this.renderer.setStyle(li, "transform", "translateY(4px)");
      // this.renderer.setStyle(li, "transform", "translateX(4px)");
    });
    li.className = 'cursor-select pointer thumbnail';
    // the whole li is a link
    const a = document.createElement('a');
    li.appendChild(a);

    // .device-photo-small
    const photo = document.createElement('div');
    photo.className = 'device-photo-small';
    const img = document.createElement('img');
    photo.appendChild(img);
    a.appendChild(photo);

    // .device-name
    const name = document.createElement('div');
    name.className = 'device-name';
    this.renderer.setStyle(name, 'color', 'unset')
    name.appendChild(document.createTextNode(''));
    a.appendChild(name);

    // button
    const button = document.createElement('button');
    this.renderer.setStyle(button, 'white-space', 'nowrap')
    button.appendChild(document.createTextNode(''));
    a.appendChild(button);
    //new
    // li.appendChild(button);

    return li;
  }

  filterItem(item, device) {
    if (this.match(device)) {
      item.classList.remove('filter-out')
      if (item.className === 'cursor-select pointer thumbnail' || item.className === 'cursor-select pointer thumbnail device-is-busy') {
        item.style.display = ''

      }
    }
    else {
      item.classList.add('filter-out')
      if (item.className === 'cursor-select pointer thumbnail device-is-busy filter-out' || item.className === 'cursor-select pointer thumbnail filter-out') {
        item.style.display = 'none';
      }
      else {
        item.style.display = ''
      }
    }
  }

  insertItem(item, deviceA) {
    return this.insertItemToSegment(item, deviceA, 0, this.items.length - 1)
  }

  // Inserts an item into a segment of the table into its correct position
  // according to current sorting. The value of `hi` is the index
  // of the last item in the segment, or -1 if none. The value of `lo`
  // is the index of the first item in the segment, or 0 if none.
  insertItemToSegment(item, deviceA, low, high) {
    let total = this.items.length
    let lo = low
    let hi = high

    if (lo > hi) {
      // This means that `lo` refers to the first item of the next
      // segment (which may or may not exist), and we should put the
      // row before it.
      this.list.insertBefore(item, lo < total ? this.items[lo] : null)
    }
    else {
      let after = true
      let pivot = 0
      let deviceB

      while (lo <= hi) {
        pivot = ~~((lo + hi) / 2)
        deviceB = this.mapping[this.items[pivot].id];

        let diff = this.compare(deviceA, deviceB)

        if (diff === 0) {
          after = true
          break
        }

        if (diff < 0) {
          hi = pivot - 1
          after = false
        }
        else {
          lo = pivot + 1
          after = true
        }
      }

      if (after) {
        this.list.insertBefore(item, this.items[pivot].nextSibling)
      }
      else {
        this.list.insertBefore(item, this.items[pivot])
      }
    }
  }

  // Checks whether the device matches the currently active filters.
  match(device) {
    if(device.serial === this.device.serial){
      return false
    }

    for (let i = 0, l = this.activeFilters.length; i < l; ++i) {
      let filter = this.activeFilters[i]
      let column
      if (filter.field) {
        column = this.columnDefinitions[filter.field]
        if (column && !column.filter(device, filter)) {
          return false
        }
      }
      else {
        let found = false
        for (let j = 0, k = this.activeColumns.length; j < k; ++j) {
          column = this.columnDefinitions[this.activeColumns[j]]
          if (column && column.filter(device, filter)) {
            found = true
            break
          }
        }
        if (!found) {
          return false
        }
      }
    }
    return true
  }

  //updated compare function
  compare(deviceA: any, deviceB: any) {
    const mapping = {
      asc: 1,
      desc: -1
    };

    let diff: number;

    // First check the priority based on enhancedStateAction
    const textA = deviceA.enhancedStateAction;
    const textB = deviceB.enhancedStateAction;

    // Default to highest possible priority number
    let priorityA = Object.keys(this.priorityOrder).length;
    let priorityB = Object.keys(this.priorityOrder).length;

    // Find matching priorities
    for (const [key, value] of Object.entries(this.priorityOrder)) {
      if (textA.includes(key)) priorityA = value;
      if (textB.includes(key)) priorityB = value;
    }

    // If priorities are different, return their difference
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // If priorities are equal, continue with other sorting criteria
    // for (let i = 0, l = this.activeSorting.length; i < l; ++i) {
    //   const sort = this.activeSorting[i];
    //   diff = this.columnDefinitions[sort.name].compare(deviceA, deviceB);
    //   if (diff !== 0) {
    //     diff *= mapping[sort.order];
    //     break;
    //   }
    // }

    return diff;
  }

  // Updates all the columns in the item. Note that the item must be in
  // the right format already (built with createItem() and patched with
  // patchItem() if necessary).
  updateItem(item, device) {
    let id = this.calculateId(device)
    // if(device.present==true && device.usable)
    // {

    //   device.enhancedStateAction='Use'
    // }
    item.id = id
    this.update(item, device)

    return item
  }

  update(li: any, device: any) {
    let a = li.firstChild
    let img = a.firstChild.firstChild
    let name = a.firstChild.nextSibling
    let nt = name.firstChild
    let button = name.nextSibling

    if (device.enhancedStateAction == "Stop Using") {
      console.log(this.currentUser.userObj.privilege,"this.currentUser");
      if (device.owner?.name !== "admin") {
        if(this.currentUser.userObj.privilege == "admin"){
          this.renderer.setStyle(button, 'background-color', '#ff6426');
          this.renderer.setStyle(button, 'color', 'Black');
        }else{
          this.renderer.setStyle(button, 'background-color', '#167ffc');
          this.renderer.setStyle(button, 'color', 'white');
        }
      } else {
        this.renderer.setStyle(button, 'background-color', '#167ffc');
        this.renderer.setStyle(button, 'color', 'white');
      }
    }
    else if (device.enhancedStateAction == "Preparing") {
      this.renderer.setStyle(button, 'color', 'rgb(255 255 255)');
      this.renderer.setStyle(button, 'background-color', 'rgb(41 121 1)');
    }
    else {
      this.renderer.setStyle(button, 'background-color', '#eaeaea');
      this.renderer.setStyle(button, 'color', '#555');
    }
    let at = button.firstChild

    let classes = 'btn btn-xs device-status '


    // .device-photo-small
    if (img.getAttribute('src') !== device.enhancedImage120 || device.ios) {
      img.setAttribute('src', device.enhancedImage120)
    }

    // .device-name
    nt.nodeValue = device.enhancedName;

    // button
    at.nodeValue = device.enhancedStateAction;

    let getStateClasses = (state) => {
      let stateClasses = {
        using: 'state-using btn-primary',
        busy: 'state-busy btn-warning',
        available: 'state-available btn-outline-primary',
        ready: 'state-ready btn-outline-primary',
        present: 'state-present btn-outline-primary',
        preparing: 'state-preparing btn-outline-primary btn-outline-success',
        unauthorized: 'state-unauthorized btn-outline-danger',
        offline: 'state-offline btn btn-light',
        automation: 'state-automation btn btn-light'
      }[state]
      if (typeof stateClasses === 'undefined') {
        stateClasses = 'btn btn-light'
      }
      return stateClasses
    }


    //stop-using button click  idar sai bhi call hota hai
    if (getStateClasses(device.state) === 'state-using btn-primary') {
      button.addEventListener('click', () => {
        this.groupService.kick(device);

        // this.Router.navigate(['devices']);
      });

    }


    button.className = classes + getStateClasses(device.state);

    if (device.state === 'available') {
      name.classList.add('state-available')
    } else {
      name.classList.remove('state-available')
    }

    if (device.usable && !device.using) {
      //a.href = '#!/control/' + device.serial
      // a.href = '';
      li.classList.remove('device-is-busy')
    }
    else if (device.using && device.usable) {
      // a.href = '#!/control/' + device.serial
      //a.href = '';

    }
    else {
      a.removeAttribute('href')
      li.classList.add('device-is-busy')
    }
    return li
  }

  // Compares an item to its siblings to see if it's still in the correct
  // position. Returns <0 if the device should actually go somewhere
  // before the previous item, >0 if it should go somewhere after the next
  // item, or 0 if the position is already correct.
  compareItem(item, device) {
    let prev = item.previousSibling
    let next = item.nextSibling
    let diff

    if (prev) {
      diff = this.compare(device, this.mapping[prev.id])
      if (diff < 0) {
        return diff
      }
    }

    if (next) {
      diff = this.compare(device, this.mapping[next.id])
      if (diff > 0) {
        return diff
      }
    }

    return 0
  }

  async getDevice(serial: string): Promise<any> {
    try {
      const device: any = await firstValueFrom(this.deviceService.get(serial));
      console.log(device, 'device in getdevice Function in slave-selection.component.ts');

      // Your existing code for stack, invited device, etc.
      let stack = this.stackService.getStack();
      if (stack.includes(device.serial)) {
        this.stackService.delete(device.serial);
        this.stackService.push(device.serial);
      } else {
        this.stackService.push(device.serial);
      }

      const invitedDevice = this.groupService.invite(device);
      this.device = device;
      this.device.using = true;
      this.device.state = "using";
      this.control = this.controlService.create(device, device.channel);

      this.settingsService.set('lastUsedDevice', serial);
      this.methodOne();
      return device;
    } catch (error) {
      console.error('Error getting device:', error);
      // Return null or a default device object, don't leave it undefined
      return null;
    }
  }

  // checkGroupValidation(groupId: any, deviceSerial: any) {
  //   this.automationService.validationUsersAsPerGroupMaster(groupId, this.device.serial).subscribe((res: any) => {
  //     if (res.success === true || res.success === "true") {
  //       this.getDevice(deviceSerial);
  //       this.deviceService.trackAll();
  //       this.deviceService.trackGroup();
  //       setTimeout(() => {
  //         this.methodOne();
  //         // this.touchHandlingMethod2();
  //         // this.keyboardHandlingMethod2();
  //       }, 2000)
  //       // window.open('#!/control/' + deviceSerial, "_self");
  //     }
  //   });
  // }

  methodOne() {
    let _global = this;

    // ios change
    if (this.device.ios) {
      this.ws = new WebSocket(this.device.url);
    }
    else {
      this.ws = new WebSocket(this.device.display.url);
    }
    // ios change
    this.ws.binaryType = 'blob';


    let adjustedBoundSize: any;
    let cachedEnabled = false;

    let canvas = this.element.querySelector('canvas');
    // let canvas = this.element.find('canvas')[0]
    //let mobile_wrapper=element.find('img')[0]
    let g = canvas.getContext('2d');
    // canvas.captureStream(30)



    let positioner = this.element.querySelector('div');

    let devicePixelRatio = window.devicePixelRatio || 1;
    let backingStoreRatio = vendorBackingStorePixelRatio(g);
    let frontBackRatio = devicePixelRatio / backingStoreRatio;

    let options = {
      autoScaleForRetina: true
      , density: Math.max(1, Math.min(1.5, devicePixelRatio || 1))
      , minscale: 0.36
    }


    this.ws.onerror = function errorListener() {
      // @todo Handle
    }

    this.ws.onclose = function closeListener() {
      // @todo Maybe handle
      _global.ws = null;
    }

    this.ws.onopen = function openListener() {
      checkEnabled()
    }

    function vendorBackingStorePixelRatio(g: any) {
      return g.webkitBackingStorePixelRatio ||
        g.mozBackingStorePixelRatio ||
        g.msBackingStorePixelRatio ||
        g.oBackingStorePixelRatio ||
        g.backingStorePixelRatio || 1
    }

    function updateBounds() {
      function adjustBoundedSize(w: any, h: any) {
        let sw = w * options.density
        let sh = h * options.density
        let f

        if (sw < (f = _global.device.display.width * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        if (sh < (f = _global.device.display.height * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        return {
          w: Math.ceil(sw)
          , h: Math.ceil(sh)
        }
      }

      // FIXME: element is an object HTMLUnknownElement in IE9
      let w = _global.screen.bounds.w = (_global.element.firstElementChild as HTMLElement).offsetWidth;
      let h = _global.screen.bounds.h = (_global.element.firstElementChild as HTMLElement).offsetHeight;
      // Developer error, let's try to reduce debug time
      if (!w || !h) {
        throw new Error(
          'Unable to read bounds; container must have dimensions'
        )
      }

      let newAdjustedBoundSize = (() => {
        switch (_global.screen.rotation) {
          case 90:
          case 270:
            return adjustBoundedSize(h, w)
          case 0:
          case 180:
          /* falls through */
          default:
            return adjustBoundedSize(w, h)
        }
      })()

      if (!adjustedBoundSize ||
        newAdjustedBoundSize.w !== adjustedBoundSize.w ||
        newAdjustedBoundSize.h !== adjustedBoundSize.h) {
        adjustedBoundSize = newAdjustedBoundSize
        onScreenInterestAreaChanged();
      }
    }

    function shouldUpdateScreen() {
      return (
        // NO if the user has disabled the screen.
        // scope.$parent.showScreen &&
        // NO if we're not even using the device anymore.
        _global.device.using &&
        // NO if the page is not visible (e.g. background tab).
        // !PageVisibilityService.hidden &&  <-------------------------- check this
        // NO if we don't have a connection yet.
        _global.ws.readyState === WebSocket.OPEN
        // YES otherwise
      )
    }

    function checkEnabled() {
      let newEnabled = shouldUpdateScreen()
      if (newEnabled === cachedEnabled) {
        updateBounds()
      }
      else if (newEnabled) {
        updateBounds()
        onScreenInterestGained()
      }
      else {
        g.clearRect(0, 0, canvas.width, canvas.height)
        onScreenInterestLost()
      }

      cachedEnabled = newEnabled
    }

    function onScreenInterestGained() {
      if (_global.ws.readyState === WebSocket.OPEN) {
        _global.ws.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
        _global.ws.send('on')
      }
    }

    function onScreenInterestAreaChanged() {
      if (_global.ws.readyState === WebSocket.OPEN) {
        _global.ws.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
      }
    }

    function onScreenInterestLost() {
      if (_global.ws.readyState === WebSocket.OPEN) {
        _global.ws.send('off')
      }
    }

    this.ws.onmessage = (() => {

      let cachedScreen = {
        rotation: 0
        , bounds: {
          x: 0
          , y: 0
          , w: 0
          , h: 0
        }
      }

      let cachedImageWidth = 0;
      let cachedImageHeight = 0;
      let cssRotation = 0;
      let alwaysUpright = false;
      let imagePool = new ImagePool(10);

      function applyQuirks(banner: any) {
        _global.element.classList.toggle(
          'quirk-always-upright', alwaysUpright = banner.quirks.alwaysUpright)
      }

      function hasImageAreaChanged(img: any) {
        return cachedScreen.bounds.w !== _global.screen.bounds.w ||
          cachedScreen.bounds.h !== _global.screen.bounds.h ||
          cachedImageWidth !== img.width ||
          cachedImageHeight !== img.height ||
          cachedScreen.rotation !== _global.screen.rotation
      }

      function isRotated() {
        return _global.screen.rotation === 90 || _global.screen.rotation === 270;
      }

      function updateImageArea(img) {
        if (!hasImageAreaChanged(img)) {
          return
        }
        let cachedImageWidth = img.width;
        let cachedImageHeight = img.height;

        if (options.autoScaleForRetina) {
          canvas.width = cachedImageWidth * frontBackRatio
          canvas.height = (cachedImageHeight * frontBackRatio)

          //mobile_wrapper.height=cachedImageHeight * frontBackRatio
          g.scale(frontBackRatio, frontBackRatio)
        }
        else {
          canvas.width = cachedImageWidth
          canvas.height = cachedImageHeight

          //mobile_wrapper.height=cachedImageHeight
          //mobile_wrapper.width=cachedImageWidth
          //mobile_wrapper.classList.remove('rotated')
        }

        cssRotation += _global.rotator(cachedScreen.rotation, _global.screen.rotation);

        canvas.style[_global.cssTransform] = 'rotate(' + cssRotation + 'deg)'

        cachedScreen.bounds.h = _global.screen.bounds.h;
        cachedScreen.bounds.w = _global.screen.bounds.w;
        cachedScreen.rotation = _global.screen.rotation;

        let canvasAspect = canvas.width / canvas.height;
        let incwidth = canvas.width * 1.035; //increase the width of the wrapper by 3.5%
        let incheight = canvas.height * 1.025; //increase the height of the wrapper by 2.5%
        _global.canvasAspect = incwidth / incheight;

        if (isRotated()) {
          //mobile_wrapper.style[cssTransform] = 'rotate(' + 180 + 'deg)'
          // mobile_wrapper.width=cachedImageHeight
          // mobile_wrapper.classList.add('rotated')
        }

        if (isRotated()) {
          _global.isScreenRotated = true;
          canvasAspect = img.height / img.width;
          _global.element.classList.add('rotated');
          _global.element.parentElement.firstElementChild.classList.add('rotatedImg');
        }
        else {
          _global.isScreenRotated = false;
          canvasAspect = img.width / img.height
          _global.element.classList.remove('rotated')
          _global.element.parentElement.firstElementChild.classList.remove('rotatedImg')
        }

        if (alwaysUpright) {
          // If the screen image is always in upright position (but we
          // still want the rotation animation), we need to cancel out
          // the rotation by using another rotation.
          positioner.style[_global.cssTransform] = 'rotate(' + -cssRotation + 'deg)'
        }

        maybeFlipLetterbox();
      }

      return function messageListener(message: any) {
        _global.screen.rotation = _global.device.display.rotation;
        //for decompression in FE
        if (message.data instanceof Blob) {
          _global.loader = false;
          _global.cursor = 'default';
          const reader = new FileReader();

          reader.onload = () => {
            const compressed = new Uint8Array(reader.result as ArrayBuffer);
            const decompressed = pako.ungzip(compressed);

            const blob = new Blob([decompressed], { type: 'image/jpeg' });

            const img = imagePool.next();
            img.onload = () => {
              updateImageArea(img);
              g.drawImage(img, 0, 0, img.width, img.height);
              // Cleanup...
            };
            img.onerror = () => {
              // Handle error and cleanup...
            };
            const url = URL.createObjectURL(blob);
            img.src = url;
          };

          reader.readAsArrayBuffer(message.data);
        }
        else if (/^start /.test(message.data)) {
          applyQuirks(JSON.parse(message.data.substr('start '.length)))
        }
        else if (message.data === 'secure_on') {
          // scope.$apply(function() {
          //   scope.displayError = 'secure'
          // })
        }
      }
    })();

    //Check this <------------------------------------------------------
    // scope.$on('fa-pane-resize', _.debounce(updateBounds, 1000))
    // scope.$watch('device.using', checkEnabled)
    // scope.$on('visibilitychange', checkEnabled)
    // scope.$watch('$parent.showScreen', checkEnabled)

    // scope.$on('guest-portrait', function () {
    //   control.rotate(0)
    // })

    // scope.$on('guest-landscape', function () {
    //   control.rotate(90)
    // })

    let canvasAspect = 1
    let parentAspect = 1

    function resizeListener() {
      parentAspect = _global.element.offsetWidth / _global.element.offsetHeight;
      maybeFlipLetterbox()
    }

    function maybeFlipLetterbox() {
      _global.element.classList.toggle(
        'letterboxed', parentAspect < canvasAspect)
    }
    // let ro = new ResizeObserver(entries => {
    //   let c = entries[0]
    //   let w = _global.element.parentElement.firstElementChild as HTMLElement;
    //   //let w = _global.element;

    //   if (this.isScreenRotated) {
    //     w.style.height = (c.contentRect.width + c.contentRect.width * 0.04) + 'px';
    //     w.style.width = (c.contentRect.height + c.contentRect.height * 0.13) + 'px';
    //   } else {
    //     w.style.width = (c.contentRect.width + c.contentRect.width * 0.13) + 'px';
    //     w.style.height = (c.contentRect.height + c.contentRect.height * 0.05) + 'px';
    //   }
    // });

    //Check this <------------------------------------------------------
    // ro.observe(canvas);
    window.addEventListener('resize', resizeListener, false)
    // scope.$on('fa-pane-resize', resizeListener)

    resizeListener();

    // scope.$on('$destroy', function () {
    //   stop()
    //   $window.removeEventListener('resize', resizeListener, false)
    // })
  }

  getTopPosition(device: any): string {
    return device?.platform == 'iOS' ? '-3vh' : '-7vh';
  }

  rotator(oldRotation: any, newRotation: any) {
    let r1 = oldRotation < 0 ? 360 + oldRotation % 360 : oldRotation % 360
    let r2 = newRotation < 0 ? 360 + newRotation % 360 : newRotation % 360

    return this.mapping[r1][r2];
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
        this.modalRef.close();;
        setTimeout(()=>{
          this.msg = ""
        },1000)
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
  }
}
